import appColors from './app_colors';

export const appBorders = {
  backrsDropShadowBorders: {
    black: {
      border: `3px solid ${appColors.container.primaryBorder}`,
      boxShadow: `5px 5px 0px 0px ${appColors.container.primaryBorder}`,
    },
    blue: {
      border: `3px solid ${appColors.container.secondaryBorder}`,
      boxShadow: `5px 5px 0px 0px ${appColors.container.secondaryBorder}`,
    },
  },
  backrsBorders: {
    black: {
      border: `3px solid ${appColors.container.primaryBorder}`,
    },
    blue: {
      border: `3px solid ${appColors.container.secondaryBorder}`,
    },
  },
};
